import { useEffect, useState } from "react";
import { requestObjectTypeDictionary, tabHeadingDictionary, redirectionTypeKey } from "../core/global/global-country-dictionary";
import LoaderImg from "../assets/images/loader.gif";
import NoSearchDataComponent from "./country-components/no-search-data";
import { Tooltip as ReactTooltip } from "react-tooltip5";
import UniqueImporterExporterCompanyName from "./country-components/unique-importer-exporter-company-name";
import commaFormat from "../utils/commaFormat";
import UpgradeIconSmall from "../assets/images/zap-icon.svg";
import Table from "../shared/trademo-datatable/DataTable";
import { getInternationalNumberSystem } from "../core/utility/utility";
import ReactTableTrademo from "../shared/trademo-datatable/react-table-trademo";
import trackingEventDictionary from "../core/dictionary/tracking-event";
import { trademoTrackingEvents } from "../core/global/trademo-tracking";
import { generateTrackingObject } from "../core/global/global-country-functions";
import ApplyFilterIcon from "@assets/images/applyFilterIcon.svg";
import RedirectProfile from "./country-components/redirect-profile";
import { Info } from "react-feather";
import DataTable from "react-data-table-component";
import AscSortIcon from "@assets/images/AscSortIcon";
import DescSortIcon from "@assets/images/DescSortIcon";
import ReactCountryFlag from "react-country-flag";
import { getTitleCase, canViewIndiaIec } from "@utils/utils";
import { useSelector } from "react-redux";
import moment from "moment";

const customStylesLogistics = {
  rows: {
    style: {
      minHeight: "48px",
      maxHeight: "fit-content",
      zIndex: 0,
      "&:nth-child(n+0)": {
        borderBottom: "none !important",
      },
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderRight: "1px solid #eaecf0",
      "&:nth-child(1)": {
        borderBottom: "none !important",
        position: "sticky",
        left: 0,
        backgroundColor: "white",
        zIndex: 1,
      },
      "&:nth-child(2)": {
        position: "sticky",
        left: "200px",
        width: "150px",
        backgroundColor: "white",
        zIndex: 1,
      },
      "&:nth-child(3)": {
        position: "sticky",
        left: "350px",
        backgroundColor: "white",
        zIndex: 1,
      },
      "&:nth-child(n+4)": {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      },
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderRight: "1px solid #eaecf0",
      "&:nth-child(1)": {
        borderBottom: "1px solid #eaecf0",
        position: "sticky",
        left: 0,
        backgroundColor: "white",
        zIndex: 1,
      },
      "&:nth-child(2)": {
        borderBottom: "1px solid #eaecf0",
        position: "sticky",
        width: "150px",
        left: "200px",
        backgroundColor: "white",
        zIndex: 1,
      },
      "&:nth-child(3)": {
        borderBottom: "1px solid #eaecf0",
        position: "sticky",
        left: "350px",
        backgroundColor: "white",
        zIndex: 1,
      },
      "&:nth-child(n+4)": {
        borderBottom: "1px solid #eaecf0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      },
    },
  },
};

const requestObjectType = { ...requestObjectTypeDictionary };
const tabKeywords = { ...tabHeadingDictionary };
export const TrendsData = ({
  dynamicTrendsData = [],
  defaultSortField,
  defaultData,
  currentTab,
  sortType,
  onSelectedRowsChange,
  paginationDefaultPage,
  paginationTotalRows,
  totalCompanyCount,
  handleChangePerPage,
  viewTrends,
  defaultTrendsData,
  handleTrendsSorting,
  selectedData,
  paginationPerPage,
  onChangeRowsPerPage,
  defaultSortAsc,
  currentPlanAccess,
  isLoaderActive,
  selectSortDefaltValueHandler,
  twoColumnMapping,
  defaultUiUeTwoLevelSelctedHeading,
  defaultUlTwoLevelSelectedHeading,
  showTwoLevel,
  isSalesForceRedirection,
  paginationIconPrevious,
  paginationIconNext,
  viewTrendsFinalSearchReqObj,
  selectedUiUeTwoLevelHeading,
  defaultPage,
  viewAllPerPage,
  updatingMustNot,
  trendsTab,
  handleIESorting,
  showPopup,
  setShowPopup,
  resetSecondLevel,
  isGridNew,
  onTableObjectChange,
  clearSelectedRows,
  onChangePage,
  fixedLengthUpto,
  analyticsCountryID,
  pathname,
  currentUserPlan,
  isRedirect,
  redirectingCompanyExporterId,
  redirectingCompanyImporterId,
  isTrendsTab,
  isTwoLevel,
  secondLevelRowDropdownValue,
  applyUIUEFilterHandler,
  sortOrderValue,
  shipmentDefaultSortValue,
}) => {
  const loader = false;
  const [data, setData] = useState([...defaultTrendsData]);
  const [defaultTrendsColumns, setDefaultTrendsColumns] = useState([]);
  const [dynamicTrendsColumns, setDynamicTrendsColumns] = useState([]);
  const [dataPerPage, setDataPerPage] = useState(25);
  const [fallbackTableHeader, setFallbackTableHeader] = useState([]);
  const [defaultTwoLevelColumn, setDefaultTwoLevelColumn] = useState(currentTab === tabKeywords.logistics ? defaultUlTwoLevelSelectedHeading : defaultUiUeTwoLevelSelctedHeading);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const userEmail = useSelector((state) => state.userDetails?.userData?.email) ?? "";
  const canViewIec = canViewIndiaIec(userEmail, creditDetails);
  useEffect(() => {
    handleOpen();
  }, [showPopup, trendsTab, showTwoLevel, handleIESorting, dynamicTrendsData]);

  useEffect(() => {
    setDataPerPage(paginationPerPage);
    setData([]);
    setTimeout(() => {
      setData(defaultTrendsData);
    }, 500);
  }, [paginationPerPage, defaultTrendsData]);

  const selectTypeHandler = (type) => {
    setDefaultTwoLevelColumn(() => type);
    setTimeout(() => {
      viewTrends(viewTrendsFinalSearchReqObj, "", type);
    }, 100);
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "62px",
        maxHeight: "fit-content",
        zIndex: 0,
        "&:nth-child(n+0)": {
          borderBottom: "none !important",
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        borderRight: "1px solid #eaecf0",
        "&:nth-child(1)": {
          borderBottom: "none !important",
          position: "sticky",
          left: 0,
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(2)": {
          position: "sticky",
          left: analyticsCountryID.toLowerCase().includes("india") ? "275px" : "200px",
          width: "200px",
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(3)": {
          position: "sticky",
          left: analyticsCountryID.toLowerCase().includes("india") ? "475px" : "400px",
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(4)": {
          position: "sticky",
          backgroundColor: "white",
          zIndex: 1,
          maxWidth: "140px !important",
          left: analyticsCountryID.toLowerCase().includes("india") ? "575px" : "550px",
        },
        "&:nth-child(5)": {
          position: "sticky",
          backgroundColor: "white",
          zIndex: 1,
          maxWidth: "140px !important",
          left: analyticsCountryID.toLowerCase().includes("india") ? "719px" : "694px",
        },
        "&:nth-child(n+6)": {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        borderRight: "1px solid #eaecf0",
        "&:nth-child(1)": {
          borderBottom: "1px solid #eaecf0",
          position: "sticky",
          left: 0,
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(2)": {
          position: "sticky",
          borderBottom: "1px solid #eaecf0",
          width: "200px",
          left: analyticsCountryID.toLowerCase().includes("india") ? "275px" : "200px",
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(3)": {
          position: "sticky",
          borderBottom: "1px solid #eaecf0",
          left: analyticsCountryID.toLowerCase().includes("india") ? "475px" : "400px",
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(4)": {
          position: "sticky",
          borderBottom: "1px solid #eaecf0",
          maxWidth: "140px !important",
          left: analyticsCountryID.toLowerCase().includes("india") ? "575px" : "550px",
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(5)": {
          position: "sticky",
          borderBottom: "1px solid #eaecf0",
          maxWidth: "140px !important",
          left: analyticsCountryID.toLowerCase().includes("india") ? "719px" : "694px",
          backgroundColor: "white",
          zIndex: 1,
        },
        "&:nth-child(n+6)": {
          display: "flex",
          borderBottom: "1px solid #eaecf0",
          justifyContent: "flex-end",
          alignItems: "center",
        },
      },
    },
  };

  const handleOpen = () => {
    let twoColumnMappingNew = { ...twoColumnMapping };
    if (currentTab === tabKeywords.exporters) {
      delete twoColumnMappingNew.derived_shipper_master_name;
    } else if (currentTab === tabKeywords.importers) {
      delete twoColumnMappingNew.derived_consignee_master_name;
    }
    let defaultTrendsClone = [
      {
        name: "S No.",
        selector: "id",
        sortable: false,
        isSticky: "start",
        left: "38px",
        grow: 0,
        maxWidth: "50px !important",
        minWidth: "50px !important",
      },
      {
        name: "Company",
        sortable: false,
        isSticky: "start",
        left: "86px",
        maxWidth: "250px !important",
        minWidth: analyticsCountryID.toLowerCase().includes("india") ? "275px !important" : "200px !important",
        selector: (row) =>
          row.sno === 1 ? (
            row.sno === 1 ? (
              <>
                {currentTab.toUpperCase() === requestObjectType.logistics ? (
                  <RedirectProfile profileType={redirectionTypeKey[row.company_type[0].split(" ").join("_")]} profileId={row.hashed_id} profileName={row.key} dataSource={analyticsCountryID} countryName={defaultData.countryCaps} countryType={defaultData.countryType} tooltipField={row.key} />
                ) : (
                  <UniqueImporterExporterCompanyName showTwoLevel={showTwoLevel} rowData={row} defaultData={defaultData} companyIdKey={isSalesForceRedirection ? null : currentTab.toUpperCase() === requestObjectType.exporters ? defaultData.trendsTableCompanyID.shipper : currentTab.toUpperCase() === requestObjectType.importers ? defaultData.trendsTableCompanyID.consignee : defaultData.trendsTableCompanyID.logistic} countryName={defaultData.countryCaps} countryType={defaultData.countryType} fixedLengthUpto={fixedLengthUpto} isRedirect={isRedirect} redirectingCompanyExporterId={redirectingCompanyExporterId} redirectingCompanyImporterId={redirectingCompanyImporterId} isTrendsTab={isTrendsTab} isTwoLevel={isTwoLevel} currentUserPlan={currentUserPlan} currentTab={currentTab} pathname={pathname} analyticsCountryID={analyticsCountryID} canViewIec={canViewIec} />
                )}
                <div className="custom-style-UIUE-total d-flex align-items-start flex-column">
                  <div>{sortType === "weight" ? "Total Weight" : sortType === "date" ? (currentTab === tabKeywords.logistics ? "Shipment Occurence" : "Total Shipments") : sortType === "shipment_value" ? "Total Shipment Value" : "Total TEUs"}</div>
                  <div>{sortType === "weight" ? "(" + commaFormat(!!row.parent_weight && !!row.parent_weight.value ? row.parent_weight.value : row.parent_weight) + ")" : sortType === "date" ? "(" + commaFormat(row.parent_doc_count) + ")" : sortType === "shipment_value" ? "(" + commaFormat(!!row.parent_shipment_value && !!row.parent_shipment_value.value ? row.parent_shipment_value.value : row.parent_shipment_value.toFixed(2)) + ")" : "(" + commaFormat(!!row.parent_teu && !!row.parent_teu.value ? row.parent_teu.value : row.parent_teu?.value === 0 ? "0" : Number.isInteger(row.parent_teu) ? row.parent_teu.toFixed(2) : row.parent_teu) + ")"}</div>
                </div>
                <div className="tw-flex tw-items-center">
                  {
                    <div className="tw-flex tw-flex-col tw-items-start">
                      {row.address && row.address !== "" && (
                        <div data-tooltip-id={`address-tooltip`} data-tooltip-content={getTitleCase(row.address)} className="tw-mt-1 tw-text-wrap tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-1">
                          {getTitleCase(row.address)}
                        </div>
                      )}
                      <div className="tw-mt-1 tw-text-xs tw-text-gray-900 tw-capitalize tw-flex tw-items-center">
                        {row.state !== "" && row.state ? getTitleCase(row.state) + ", " : <></>}
                        {getTitleCase(row.country)}
                        <ReactCountryFlag className="trademo-search-flag ml-1" countryCode={row.country_code} svg />
                      </div>
                    </div>
                  }
                </div>
              </>
            ) : (
              ""
            )
          ) : Number.isInteger(row.sno) ? (
            ""
          ) : currentTab.toUpperCase() === requestObjectType.logistics ? (
            <RedirectProfile profileType={redirectionTypeKey[row.company_type[0].split(" ").join("_")]} profileId={row.hashed_id} profileName={row.key} dataSource={analyticsCountryID} countryName={defaultData.countryCaps} isTrendsTab={isTrendsTab} isTwoLevel={isTwoLevel} fixedLengthUpto={35} countryType={defaultData.countryType} tooltipField={row.key} />
          ) : (
            <>
              <UniqueImporterExporterCompanyName rowData={row} companyIdKey={isSalesForceRedirection ? null : currentTab.toUpperCase() === requestObjectType.exporters ? defaultData.trendsTableCompanyID.shipper : currentTab.toUpperCase() === requestObjectType.importers ? defaultData.trendsTableCompanyID.consignee : defaultData.trendsTableCompanyID.logistic} countryName={defaultData.countryCaps} countryType={defaultData.countryType} isRedirect={isRedirect} redirectingCompanyExporterId={redirectingCompanyExporterId} redirectingCompanyImporterId={redirectingCompanyImporterId} isTrendsTab={isTrendsTab} fixedLengthUpto={fixedLengthUpto} showTwoLevel={showTwoLevel} currentUserPlan={currentUserPlan} currentTab={currentTab} pathname={pathname} analyticsCountryID={analyticsCountryID} canViewIec={canViewIec} />
              <div className="tw-flex tw-flex-col tw-items-start">
                {row.address && row.address !== "" && (
                  <div data-tooltip-id={`address-tooltip`} data-tooltip-content={getTitleCase(row.address)} className="tw-mt-1 tw-text-wrap tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-1">
                    {getTitleCase(row.address)}
                  </div>
                )}
                <div className="tw-mt-1 tw-text-xs tw-text-gray-900 tw-capitalize tw-flex tw-items-center">
                  {row.state !== "" && row.state ? getTitleCase(row.state) + ", " : <></>}
                  {getTitleCase(row.country)}
                  <ReactCountryFlag className="trademo-search-flag ml-1" countryCode={row.country_code} svg />
                </div>
              </div>
            </>
          ),
      },
      {
        name: <div className="d-flex align-items-center">Type</div>,
        sortable: false,
        isSticky: "start",
        key: "type",
        left: currentTab === tabKeywords.logistics ? "285px" : "295px",
        maxWidth: "150px !important",
        minWidth: "150px !important",
        grow: 3,
        selector: (row) =>
          showTwoLevel ? (
            row.sno === 1 ? (
              <div className="w-80 d-flex align-items-baseline">
                {row.company_type.map((item, index) => {
                  const typeCompany = item.includes(" ") ? <span className="text-capitalize">{item}</span> : item.toUpperCase();

                  if (index === 0) {
                    return (
                      <>
                        <span key={index} className="tw-block tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-mr-1 tw-w-fit tw-mb-0.5">
                          {typeCompany}
                          {row.company_type.length > 1 && (
                            <ReactTooltip id={`tooltip-${row.id}`} place="top" effect="solid">
                              {row.company_type.slice(1).map((item, i) => {
                                return (
                                  <div className="text-capitalize" key={i}>
                                    {item}
                                  </div>
                                );
                              })}
                            </ReactTooltip>
                          )}
                        </span>
                        <div>
                          {row.company_type.length > 1 && (
                            <span data-tip data-for={`tooltip-${row.id}`} className="tw-bg-gray-100 tw-rounded-xl tw-px-[4.8px] tw-py-[1.6px] tw-cursor-pointer tw-font-medium tw-text-gray-600">
                              +{row.company_type.length - 1}
                            </span>
                          )}
                        </div>
                      </>
                    );
                  }
                  return null;
                })}
              </div>
            ) : (
              ""
            )
          ) : (
            <div className="w-80 d-flex align-items-baseline">
              {row?.company_type?.map((item, index) => {
                const typeCompany = item.includes(" ") ? <span className="text-capitalize">{item}</span> : item.toUpperCase();

                if (index === 0) {
                  return (
                    <>
                      <span key={index} className="tw-block tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-mr-1 tw-w-fit tw-mb-0.5">
                        {typeCompany}
                        {row.company_type.length > 1 && (
                          <ReactTooltip id={`tooltip-${row.id}`} place="top" effect="solid">
                            {row.company_type.slice(1).map((item, i) => {
                              return (
                                <div className="text-capitalize" key={i}>
                                  {item}
                                </div>
                              );
                            })}
                          </ReactTooltip>
                        )}
                      </span>
                      <div>
                        {row.company_type.length > 1 && (
                          <span data-tip data-for={`tooltip-${row.id}`} className="tw-bg-gray-200 tw-rounded-xl tw-px-[4.8px] tw-py-[1.6px] tw-cursor-pointer tw-font-medium tw-text-gray-600">
                            +{row.company_type.length - 1}
                          </span>
                        )}
                      </div>
                    </>
                  );
                }
                return null;
              })}
            </div>
          ),
      },
      {
        key: "subKey",
        name: (
          <div className="position-relative twolevel">
            <div
              className="cursor-pointer tw-flex tw-items-center"
              onClick={(e) => {
                if (currentTab === tabKeywords.exporters) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsAttribute, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                } else if (currentTab === tabKeywords.importers) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends2ndLevelAnalyticsAttribute, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                } else {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends2ndLevelAnalyticsAttribute, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                }
                e.stopPropagation();
                setShowPopup(true);
              }}>
              <span>{twoColumnMapping ? twoColumnMapping[defaultTwoLevelColumn] : ""}</span>
              <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1674122072/intel/icons/edit_iohyzc.svg" />
            </div>
            {showPopup ? (
              <div className="position-absolute twoLevelPopOver tw-top-6">
                {Object.keys(twoColumnMappingNew).map((item) =>
                  item !== defaultUiUeTwoLevelSelctedHeading.key || item !== defaultUlTwoLevelSelectedHeading.key ? (
                    <div
                      onClick={() => {
                        selectedUiUeTwoLevelHeading(item);
                        setShowPopup(false);
                        selectTypeHandler(item);
                        updatingMustNot(false);
                        resetSecondLevel();
                      }}
                      className={`px-2 twolevel_option_icons cursor-pointer ${item === defaultTwoLevelColumn ? "py-2 twolevel_option_icons-selected" : "py-2"}`}
                      key={item}>
                      <p className={`d-flex justify-content-between m-0 `}>
                        <span className="cursor-pointer">{item !== defaultUiUeTwoLevelSelctedHeading.key || item !== defaultUlTwoLevelSelectedHeading.key ? twoColumnMapping[item] : ""}</span>
                        <span>{item === defaultTwoLevelColumn ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                      </p>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        ),
        sortable: false,
        grow: 2,
        isSticky: "start",
        left: "209px",
        minWidth: "200px !important",
        maxWidth: "200px !important",
        selector: (row) => (
          <div className="text-capitalize">
            <p data-tip={row.subKey} data-for="sub-key" className={`m-0 d-flex align-items-center ${row.subKey ? "h-100" : ""}`}>
              {row.subKey ? (typeof row.subKey === "string" ? row.subKey.toUpperCase().slice(0, 42) : row.subKey.slice(0, 42)) : ""}
              {!!row.subKey && row.subKey.length > 42 ? "..." : ""}
            </p>
            <div className="position-relative">
              <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                  ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 32
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 32) + "..."
                    : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                  : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 32
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 32) + "..."
                      : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                    : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                      ? (row.field1 + " → " + row.field2).length > 32
                        ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 32) + "..."
                        : (row.field1 + " → " + row.field2).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string"
                        ? row.field1.toUpperCase()
                        : ""}
              </div>
            </div>
            <ReactTooltip
              getContent={[
                (dataTip) => {
                  return (
                    <span>
                      {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                      {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                      {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                    </span>
                  );
                },
                100,
              ]}
              className="trademo-tooltip"
              backgroundColor="#8C8C8C"
              textColor="#FFFFFF"
              place="bottom"
              id="sub-key"
            />
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="sub-key1" />
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="sub-key1" />
          </div>
        ),
      },
      {
        name: <div className="text-capitalize">{sortType === "date" ? (currentTab === tabKeywords.logistics ? "Shipment Occurence" : "Total Shipments") : sortType === "teu" ? "Total TEUs" : sortType === "weight" ? "Total Weight(Kg)" : sortType === "shipment_value" ? "Total Shipment Value(USD)" : selectSortDefaltValueHandler ? selectSortDefaltValueHandler.table_header : "Total Shipment Value(USD)"}</div>,
        sortable: false,
        isSticky: "start",
        left: currentTab === tabKeywords.logistics ? "434px" : analyticsCountryID.toLowerCase().includes("india") ? "384px" : "285px",
        grow: 2,
        key: sortType,
        maxWidth: "150px !important",
        selector: (row) => (
          <span>
            {!!currentPlanAccess && currentPlanAccess[sortType] === false ? (
              <span data-for="teuHide" data-tip={"To view, you would need to upgrade to higher plan."}>
                <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span className="ml-1">
                  <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                </span>
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="teuHide" />
              </span>
            ) : (!!row && !!row[sortType] && !!row[sortType].value) || (!!row && !!row[sortType] && !!row[sortType]) ? (
              typeof row[sortType] === "number" && !Number.isInteger(row[sortType]) ? (
                commaFormat(row[sortType].toFixed(2))
              ) : typeof row[sortType] === "object" && row[sortType].value === 0 ? (
                row[sortType].value
              ) : (
                commaFormat(row[sortType])
              )
            ) : sortType === "date" ? (
              commaFormat(row.doc_count)
            ) : (
              "NA"
            )}
          </span>
        ),
      },
      {
        name: <div className="d-flex align-items-center">{`First ${currentTab === tabKeywords.importers ? "Imported" : currentTab === tabKeywords.exporters ? "Exported" : ""} Date`}</div>,
        sortable: false,
        minWidth: "144px !important",
        isSticky: "start",
        key: "oldest_shipment_date",
        left: analyticsCountryID.toLowerCase().includes("india") ? "562px" : "465px",
        selector: (row) => (
          <div>
            {row.oldest_shipment_date !== "" ? (
              <>
                <span>{moment(row.oldest_shipment_date).format("MMM DD, YYYY")}</span>
              </>
            ) : (
              <></>
            )}
          </div>
        ),
      },
      {
        name: <div className="d-flex align-items-center">{`Last ${currentTab === tabKeywords.importers ? "Imported" : currentTab === tabKeywords.exporters ? "Exported" : ""}  Date`}</div>,
        sortable: false,
        minWidth: "144px !important",
        isSticky: "start",
        key: "recent_shipment_date",
        left: analyticsCountryID.toLowerCase().includes("india") ? "705px" : "609px",
        selector: (row) => (
          <div>
            {row.recent_shipment_date !== "" ? (
              <>
                <span>{moment(row.recent_shipment_date).format("MMM DD, YYYY")}</span>
              </>
            ) : (
              <></>
            )}
          </div>
        ),
      },
      {
        name: (
          <div className="d-flex align-items-center">
            % Overall Change
            <div>
              <Info className="mx-1" color="#8C8C8C" size={13} data-tip={"% Overall Change is the relative percentage change between the Trade Volume for the earliest and latest time period"} data-for="xyz" />
              <ReactTooltip className="overall-change__tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="xyz" />
            </div>
          </div>
        ),
        sortable: false,
        minWidth: "144px !important",
        selector: (row) => <div>{row.overall_percent_change >= 0 ? <span className="positive">↑{row.overall_percent_change.toFixed(2)}%</span> : <span className="negative">↓{Math.abs(row.overall_percent_change).toFixed(2)}%</span>}</div>,
      },
    ];
    let arr = [];
    dynamicTrendsData?.map((item, index) => {
      const column = {
        name:
          index === 0 ? (
            <div className={`tw-flex tw-items-center tw-justify-end tw-w-full tw-h-full cursor-pointer ${currentTab === tabKeywords.exporters || currentTab === tabKeywords.importers || currentTab === tabKeywords.logistics ? "trends-tooltip-cell" : ""}`} data-tip="Trends are updated to the latest shipment date" data-for={`header-tooltip-${index}`} style={{ whiteSpace: "nowrap" }}>
              <div>
                {item}
                <svg xmlns="http://www.w3.org/2000/svg" height="8px" viewBox="0 -960 960 960" width="8px" fill="#101828">
                  <path d="M454-164v-252.85L274.92-238.16l-36.76-36.76L416.85-454H164v-52h252.85L238.16-685.08l36.76-36.38L454-542.77V-796h52v253.23l179.08-178.69 36.38 36.38L542.77-506H796v52H542.77l178.69 179.08-36.38 36.76L506-416.85V-164h-52Z" />
                </svg>
              </div>
              <ReactTooltip id={`header-tooltip-${index}`} className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" />
            </div>
          ) : (
            <div className="tw-flex tw-justify-end">{item}</div>
          ),
        sortable: false,
        minWidth: "100px !important",
        grow: 0,
        separator: true,
        selector: (row) => (
          <div className="text-right">
            <span className="">{row[item] !== undefined && row[item] !== null && row[item].value !== undefined && row[item].value !== null ? getInternationalNumberSystem(row[item].value) : ""}</span>
            <br />
            {index !== dynamicTrendsData.length - 1 ? row[item] && (row[item].percent_change || row[item].percent_change === 0) && row[item].percent_change >= 0 ? <span className="growth-change positive text-right">↑{row[item].percent_change.toFixed(2)}%</span> : row[item] && (row[item].percent_change || row[item].percent_change === 0) ? <span className="growth-change negative text-right">↓{Math.abs(row[item].percent_change).toFixed(2)}%</span> : "" : ""}
          </div>
        ),
      };
      arr.push(column);
    });

    if (!showTwoLevel) {
      let redirectingFromProfile = new URLSearchParams(location.search).get("redirectingFrom");

      if (currentTab !== tabKeywords.logistics) {
        const applyFilter = (row) => {
          applyUIUEFilterHandler([{ company_name: row.key, company_id: row?.hashed_id || row?.shipper_company_id || row?.consignee_company_id }]);
          if (currentTab === tabKeywords.importers) {
            if (redirectingFromProfile) {
              checkPendoEventForCompanyRedirection(`${redirectingFromProfile}_redirection_unique_importer_tab_trends_apply_filter`);
            } else {
              checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImporterTabTrendsApplyFilter, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
            }
          } else {
            if (redirectingFromProfile) {
              checkPendoEventForCompanyRedirection(`${redirectingFromProfile}_redirection_unique_exporter_tab_trends_apply_filter`);
            } else {
              checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExporterTabTrendsApplyFilter, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
            }
          }
        };

        arr.push({
          key: "",
          omit: false,
          name: <div className="stickyEnd">Apply Filter</div>,
          button: true,
          selector: (row) => (
            <p className="stickyEnd tw-cursor-pointer" onClick={() => applyFilter(row)}>
              <img src={ApplyFilterIcon} />
            </p>
          ),
          isSticky: "end",
        });
      }
      arr.unshift(...defaultTrendsClone);
    }
    if (!showTwoLevel) {
      const filteredColumns = currentTab === tabKeywords.logistics ? arr.filter((column) => column.key !== "subKey" && column.key !== "oldest_shipment_date" && column.key !== "recent_shipment_date") : arr.filter((column) => column.key !== "subKey" && column.key !== "type");
      filteredColumns.map((item) => {
        if (item.key === "date") {
          item.key = "doc_count";
        }
        return item;
      });
      setDynamicTrendsColumns(filteredColumns);
      setFallbackTableHeader(filteredColumns);
    }
    if (showTwoLevel) {
      const combinedColumns = [...defaultTrendsClone, ...arr];
      let filteredColumns = [];
      if (currentTab !== tabKeywords.logistics) {
        filteredColumns = combinedColumns.filter((column) => column.name !== "S No." && column.key !== "type");
      } else {
        filteredColumns = combinedColumns.filter((column) => column.name !== "S No." && column.key !== "oldest_shipment_date" && column.key !== "recent_shipment_date");
      }

      setDefaultTrendsColumns(filteredColumns);
      setFallbackTableHeader(filteredColumns);
    }
  };

  const handleSorting = (sortField, sortDirection) => {
    handleTrendsSorting(sortField, sortDirection);
  };

  const mapSelectedValue = (data) => {
    setTimeout(() => {
      onSelectedRowsChange([...data]);
    }, 100);
  };
  const handlePageChange = (e) => {
    if (!showTwoLevel) {
      handleChangePerPage(e);
      if (defaultTrendsData.length <= e * dataPerPage) {
        if (e * dataPerPage <= paginationTotalRows) {
          if (!isGridNew) {
            viewTrends();
          }
        }
      }
    }
  };
  useEffect(() => {
    let val = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination select option");
    if (!!val && !!val.length) {
      val[0].textContent = 5;
      val[1].textContent = 10;
      val[2].textContent = 20;
    }
    let value = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination select option");
    if (!!value && !!value.length) {
      value[0].textContent = 5;
      value[1].textContent = 10;
      value[2].textContent = 20;
    }
    let range = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination span");
    if (!!range && !!range.length) {
      let toPage = (defaultPage * viewAllPerPage) / secondLevelRowDropdownValue - 1;
      let fromPage = toPage - viewAllPerPage / secondLevelRowDropdownValue + 1;
      range[1].textContent = paginationTotalRows >= 5 ? `${fromPage + 1} - ${toPage + 1 > paginationTotalRows ? paginationTotalRows : toPage + 1} of ${paginationTotalRows}` : `${fromPage + 1} - ${paginationTotalRows} of ${paginationTotalRows}`;
    }
    let prevPage = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination #pagination-previous-page");
    if (!!prevPage && !!prevPage.length && defaultPage > 1) {
      prevPage[0].removeAttribute("disabled");
    }
    let totalPages = Math.floor(totalCompanyCount / (dataPerPage / secondLevelRowDropdownValue)) + 1;
    let nextPage = document.getElementById("pagination-next-page");

    if (nextPage) {
      if (defaultPage >= totalPages) {
        nextPage.setAttribute("disabled", true);
        nextPage.style.opacity = "0.4";
        nextPage.style.cursor = "not-allowed";
      } else {
        nextPage.removeAttribute("disabled");
      }
    }
    let rows = document.querySelectorAll(".lvl-two-table-container-left .rdt_TableRow");
    if (!!rows && !!rows.length) {
      defaultTrendsData.forEach((item, index) => {
        if (!item.showBorder && !!rows[index] && !!rows[index].firstChild) {
          let firstChild = rows[index].firstChild;
          firstChild.style.setProperty("border-bottom", "none", "important");
        }
        if (!item.showBorder && !!rows[index] && !!rows[index] && currentTab === tabKeywords.logistics) {
          rows[index].firstChild.nextSibling.style.setProperty("border-bottom", "none", "important");
        }
      });
    }
    let pagination = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination");
    if (!!pagination && !!pagination.length && !!defaultTrendsData && defaultTrendsData.length < 8) {
      pagination[0].style.marginTop = -(48 * (10 - defaultTrendsData.length)) + 30 + "px";
    }
  });
  const checkPendoEventForCompanyRedirection = (event) => {
    let tempEvent;
    for (let [key, value] of Object.entries(trackingEventDictionary)) {
      if (event && key && value === event) {
        tempEvent = key;
      }
    }
    tempEvent = "companyRedirection" + tempEvent[0].toUpperCase() + tempEvent.slice(1);
    if (tempEvent && trackingEventDictionary && trackingEventDictionary[tempEvent] && isRedirect && (redirectingCompanyExporterId || redirectingCompanyImporterId)) {
      trademoTrackingEvents(trackingEventDictionary[tempEvent], generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    } else {
      trademoTrackingEvents(event, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    }
  };

  return (
    <>
      <div className="card w-100 tw-border tw-border-gray-200 tw-rounded-lg trademo-uiue-datatable tw-overflow-hidden">
        {loader && loader !== "" ? (
          <>
            <div className="container py-5 my-5 loading-container">
              <div className="text-center pt-3">
                <img src={LoaderImg} alt="description of gif" />
              </div>
            </div>
          </>
        ) : (
          <>
            {showTwoLevel && isLoaderActive ? (
              <>
                <Table className="trademo-datatable trademo-custom-table2" columns={fallbackTableHeader} data={[]} noDataComponent={isLoaderActive ? "" : (!!data && !!data.length) || (!!defaultTrendsData && !!defaultTrendsData.length) ? "" : "No Shipments Found. Please try another search"} />
              </>
            ) : !defaultTrendsData.length || !defaultTrendsData ? (
              <Table className="trademo-datatable trademo-custom-table2 " columns={fallbackTableHeader} data={[]} noDataComponent={isLoaderActive ? "" : (!!data && !!data.length) || (!!defaultTrendsData && !!defaultTrendsData.length) ? "" : "No Shipments Found. Please try another search"} />
            ) : (
              <div className="">
                <div className={`${showTwoLevel ? "" : ""} pr-0 pl-0 ${showTwoLevel ? " lvl-two-table-container-left" : isGridNew ? "simple-trends-table-data" : ""}`}>
                  {(dynamicTrendsData?.length && defaultTrendsColumns?.length) || (dynamicTrendsColumns?.length && dataPerPage) ? (
                    isGridNew && !showTwoLevel ? (
                      // This is trends - level 1 - table
                      <>
                        <ReactTableTrademo
                          columns={dynamicTrendsColumns}
                          data={defaultTrendsData}
                          paginationTotalRows={paginationTotalRows}
                          onSelectedRowsChange={(selectedRows) => {
                            mapSelectedValue(selectedRows);
                          }}
                          onSort={(e) => handleSorting(e, sortOrderValue === "desc" ? "desc" : "desc")}
                          sortOrderValue={sortOrderValue}
                          defaultSortField={defaultSortField}
                          defaultSortAsc={defaultSortAsc}
                          paginationPerPage={dataPerPage}
                          hidePagination={showTwoLevel}
                          onChangeRowsPerPage={onChangeRowsPerPage}
                          onTableObjectChange={onTableObjectChange}
                          onChangePage={onChangePage}
                          paginationDefaultPage={paginationDefaultPage}
                          noDataComponent="No Shipments Found. Please try another search"
                          clearSelectedRows={clearSelectedRows}
                          selectedData={selectedData}
                          hideSorting={true}
                          fixSelection="start"
                          options={[25, 50, 100]}
                          shipmentDefaultSortValue={shipmentDefaultSortValue}
                          blockAscSorting={true}
                        />
                        <ReactTooltip className="trademo-tooltip !tw-z-[9999]" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={`address-tooltip`} />
                      </>
                    ) : (
                      // trends level 2 - table
                      <>
                        <div className="tw-w-full tw-overflow-x-auto lvl-two-table-container-left">
                          <DataTable
                            title="Data2"
                            className="!tw-min-h-[408px]"
                            columns={defaultTrendsColumns}
                            data={!showTwoLevel && data ? data : !!defaultTrendsData && defaultTrendsData !== "" ? defaultTrendsData : []}
                            customStyles={currentTab === tabKeywords.logistics ? customStylesLogistics : customStyles}
                            paginationDefaultPage={paginationDefaultPage}
                            onSort={(e) => handleSorting(e, sortOrderValue === "desc" ? "asc" : "desc")}
                            sortServer={true}
                            sortIcon={sortOrderValue === "desc" ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} />}
                            paginationTotalRows={paginationTotalRows}
                            pagination
                            persistTableHead
                            paginationRowsPerPageOptions={showTwoLevel ? [secondLevelRowDropdownValue * 5, secondLevelRowDropdownValue * 10, secondLevelRowDropdownValue * 20] : [25, 50, 100]}
                            paginationPerPage={dataPerPage}
                            onChangePage={(e) => handlePageChange(e ? e : 1)}
                            onChangeRowsPerPage={(e) => onChangeRowsPerPage(e)}
                            paginationIconPrevious={paginationIconPrevious ? paginationIconPrevious : null}
                            paginationIconNext={paginationIconNext ? paginationIconNext : null}
                          />
                          <ReactTooltip className="trademo-tooltip !tw-z-[9999]" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={`address-tooltip`} />
                        </div>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        {defaultTrendsColumns.length === 0 && dataPerPage.length === 0 && dynamicTrendsColumns.length === 0 && defaultTrendsData.length === 0 && <NoSearchDataComponent content="No Shipments Found. Please try another search" />}
      </div>
    </>
  );
};
